/* globals $ */

// This is the splash page for mobile web and the native apps
// ----------------------------------------------------------------------------

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import classnames from "classnames";

import Link from "shared/components/Link";
import Context from "shared/util/Context";
import ClientStats from "shared/util/ClientStats";
import isApp from "shared/util/isApp";

import TermsOfService from "shared/components/TermsOfService";
import Logo from "apps/splash_mobile/components/Logo";
import Str from "shared/components/Str";

import { URLS } from "apps/signup/util/constants";

import {
	loadSplash,
	clickSignup,
	clickLogin,
	CONFIRM_RECAPTCHA_SUCCESS,
} from "ducks/splash";
import { confirmToken } from "ducks/recaptcha";

import { recordStartOnboarding } from "./util/web";

import "./App.scss";

class App extends React.Component {
	static propTypes = {
		onLoadSplash: PropTypes.func.isRequired,
		onClickSignup: PropTypes.func.isRequired,
		onClickLogin: PropTypes.func.isRequired,
		confirmRecaptchaToken: PropTypes.func.isRequired,
	};

	state = {
		recaptchaToken: null,
	};

	componentDidMount() {
		this.props.onLoadSplash();

		ClientStats.update({
			statname: "splash - onboarding funnel - view",
			unique: true,
		});

		if (isApp()) {
			$(this.container).immobilize(true, true);
		}
	}

	_onShowSignup = () => {
		this.props.onClickSignup();
		recordStartOnboarding();
	};

	_onShowLogin = () => {
		this.props.onClickLogin();
	};

	_setCaptchaToken = (token) => {
		this.setState({ recaptchaToken: token });
	}

	_trackRecaptchaScore = () => {
		const { confirmRecaptchaToken } = this.props;
		const { recaptchaToken } = this.state;
		confirmRecaptchaToken({
			type: CONFIRM_RECAPTCHA_SUCCESS,
			token: recaptchaToken,
			isCaptchaShowing: false,
			page: "splash",
		});
	}

	render() {
		let loginLink = URLS.LOGIN;

		if (isApp()) {
			loginLink = URLS.LOGIN_APPS;
		}

		const isIndia = Context.has("INDIAN_SPLASH_PAGES");

		return (
			<div
				className={classnames("splash", {
					"splash--is-india": isIndia,
				})}
				ref={(div) => { this.container = div; }}
			>
				<div className="splash-wrapper">
					<div className="splash-top">
						<Logo />

						<Link
							className="splash-signin"
							to={loginLink}
							onClick={this._onShowLogin}
						>
							<Str>Sign in</Str>
						</Link>
					</div>

					{isIndia &&
						<div className="splash-india-image">
							<div className="splash-india-image-content" />
						</div>
					}

					{!isIndia &&
						<Fragment>
							<div className="splash-header">
								<Str className="splash-header">
									You’re about to go on better dates
								</Str>
							</div>

							<div className="splash-subheader">
								<Str>
									We go beneath the surface to show off the real you.
									How’s that for a change?
								</Str>
							</div>
						</Fragment>
					}

					<div className="splash-bottom">
						<TermsOfService />

						<Link
							className="splash-bottom-button"
							to={URLS.SIGNUP}
							onClick={() => {
								this._onShowSignup();
								this._trackRecaptchaScore();
							}}
						>
							<Str>Join OkCupid</Str>
						</Link>

						<GoogleReCaptcha
							onVerify={this._setCaptchaToken}
							action="splash"
						/>
					</div>
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = {
	onLoadSplash: loadSplash,
	onClickSignup: clickSignup,
	onClickLogin: clickLogin,
	confirmRecaptchaToken: confirmToken,
};

export { App };
export default connect(null, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/apps/splash_mobile/App.jsx